import { FilePlus2, ShieldCheck, Timer } from "lucide-react";
import type { ReactNode } from "react";
import Logo from "@/components/ui/Logo";

const FEATURES = [
  { icon: FilePlus2, text: "Instant mandate creation" },
  { icon: Timer, text: "Real-time status tracking" },
  { icon: ShieldCheck, text: "Secure and compliant" },
];

interface AuthShellProps {
  children: ReactNode;
}

export default function AuthShell({ children }: AuthShellProps) {
  return (
    <div className="flex min-h-screen w-full bg-white">
      {/* Left brand panel */}
      <div className="relative hidden w-[55%] flex-col overflow-hidden bg-sidebar lg:flex">
        <div className="pointer-events-none absolute inset-0 bg-gradient-to-br from-primary-900/60 via-transparent to-transparent" />
        <div className="pointer-events-none absolute -right-32 top-1/3 h-96 w-96 rounded-full bg-primary-500/10 blur-3xl" />

        <div className="relative z-10 flex h-full flex-col p-12">
          <Logo variant="light" size="lg" />

          <div className="flex flex-1 flex-col justify-center">
            <h1 className="max-w-md text-[32px] font-bold leading-tight text-white">
              Digital Mandate Management, Simplified
            </h1>
            <p className="mt-3 max-w-sm text-base text-slate-400">
              Create, track and manage eNACH mandates in one place.
            </p>

            <div className="mt-10 flex flex-col gap-5">
              {FEATURES.map((f) => (
                <div key={f.text} className="flex items-center gap-3.5">
                  <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-white">
                    <f.icon className="h-[18px] w-[18px]" />
                  </span>
                  <span className="text-sm text-white">{f.text}</span>
                </div>
              ))}
            </div>
          </div>

          <p className="text-xs text-slate-400">
            Secure eNACH mandate processing
          </p>
        </div>
      </div>

      {/* Right panel */}
      <div className="flex w-full items-center justify-center bg-white px-6 lg:w-[45%]">
        <div className="w-full max-w-[400px]">
          <div className="mb-8 lg:hidden">
            <Logo size="lg" />
          </div>
          {children}
        </div>
      </div>
    </div>
  );
}